import * as React from 'react';
import { ErrorLogComponent } from '@cian/error-log-component';
import { useApplicationContext } from '../../utils/withApplicationContext';

import { useSelector } from 'react-redux';
import { trackServiceBannerClickChange } from './tracking';
import { ServiceBanner } from '../../components/ServiceBanner';
import { getNewbuildingId } from '../../selectors/newbuilding';

export interface IServiceBannerContainerProps {
  type: 'builder' | 'seller';
  isMultiSeller?: boolean;
}

export const ServiceBannerContainer = ({ type, isMultiSeller }: IServiceBannerContainerProps) => {
  const { logger } = useApplicationContext();
  const newbuildingId = useSelector(getNewbuildingId);

  const onClick = React.useCallback(() => {
    trackServiceBannerClickChange(newbuildingId);
  }, [newbuildingId]);

  return (
    <ErrorLogComponent logger={logger}>
      <ServiceBanner type={type} isMultiSeller={isMultiSeller} onClick={onClick} />
    </ErrorLogComponent>
  );
};
